import {
  BaseButton,
  Button,
  DefaultButton,
  mergeStyleSets,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
  Stack
} from 'office-ui-fabric-react';
import * as React from 'react';
import ReactSVG from 'react-svg';
import './Auth.css';

export interface IAuthState {}

export interface IAuthProps {
  buttonShow?: boolean;
  buttonText: string;
  buttonDisabled: boolean;
  isProcessing: boolean;
  buttonOnClick: () => void;
  messageText?: string;
  messageType?: MessageBarType;
  onKeyPress: (ev: React.KeyboardEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement | BaseButton | Button>) => void;
}

class Auth extends React.PureComponent<IAuthProps, IAuthState> {
  public static defaultProps = {
    buttonShow: true
  };

  constructor(props: IAuthProps) {
    super(props);

    this.state = {};
  }

  public componentDidMount() {}

  public render(): JSX.Element {
    const styles = mergeStyleSets({
      root: {
        background: 'url("' + process.env.PUBLIC_URL + '/background.jpg") 50% fixed',
        backgroundSize: 'cover',
        height: '100vh'
      },
      stackMargin: {
        selectors: {
          '@media screen and (min-width: 640px)': {
            marginRight: '20%'
          },
          '@media screen and (max-width: 640px)': {
            margin: 'auto',
            width: '90%'
          }
        }
      },
      login: {
        background: '#ffffff',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.3)',
        selectors: {
          '@media screen and (min-width: 640px)': {
            width: '400px',
            marginTop: '35%'
          },
          '@media screen and (max-width: 640px)': {
            width: '100%',
            marginTop: '0'
          }
        }
      },
      loginMsg: {
        selectors: {
          '@media screen and (min-width: 640px)': {
            width: '400px'
          },
          '@media screen and (max-width: 640px)': {
            width: '100%'
          }
        }
      },
      inputs: {
        padding: '0 20px',
        selectors: {
          '& > div': {
            marginBottom: '5px'
          }
        }
      }
    });

    return (
      <div className={styles.root}>
        <Stack horizontal horizontalAlign="end" verticalFill>
          <Stack verticalAlign={'start'} style={{ background: 'rgba(255, 255, 255, 0.62)' }} className={styles.stackMargin}>
            <Stack.Item>
              <div className={styles.login}>
                <ReactSVG
                  src={process.env.PUBLIC_URL + '/KTX_Logo_4.svg'}
                  fallback={() => <span>KTX</span>}
                  loading={() => <span>KTX</span>}
                  afterInjection={(error, svg) => {
                    if (error) {
                      console.error(error);
                      return;
                    }
                  }}
                  beforeInjection={svg => {
                    svg.classList.add('ktxlogo');
                    svg.setAttribute('style', 'max-width: 250px; display: block; margin: auto; padding: 30px 0 30px 0');
                  }}
                  //                  svgStyle={{ maxWidth: '250px', display: 'block', margin: 'auto', padding: '30px 0 30px 0' }}
                  renumerateIRIElements={false}
                  wrapper="span"
                  className="ktxlogowrapper"
                />
                <div className={styles.inputs} onKeyPress={this.props.onKeyPress}>
                  {this.props.children}
                </div>
                <div className="footer" style={{ visibility: this.props.buttonShow ? 'visible' : 'hidden' }}>
                  <DefaultButton
                    primary={true}
                    type={'submit'}
                    onClick={this.props.buttonOnClick}
                    disabled={this.props.buttonDisabled}
                    style={{
                      width: '100%',
                      height: '60px',
                      marginTop: '20px',
                      border: '0px solid rgba(0,0,0,0.1)'
                    }}
                  >
                    {this.props.isProcessing ? (
                      <Spinner size={SpinnerSize.large} label="Submitting..." ariaLive="assertive" labelPosition="right" />
                    ) : (
                      <div style={{ fontSize: '17px' }}>
                        {/*  <Icon iconName="FollowUser" style={{ marginRight: 10 }} /> */}
                        {this.props.buttonText}
                      </div>
                    )}
                  </DefaultButton>
                </div>
              </div>
              {this.props.messageText ? (
                <div style={{ backgroundColor: '#fff' }} className={styles.loginMsg}>
                  <MessageBar messageBarType={this.props.messageType} isMultiline={true}>
                    {this.props.messageText}
                  </MessageBar>
                </div>
              ) : null}
            </Stack.Item>
          </Stack>
        </Stack>
      </div>
    );
  }
}

export default Auth;
